'use client';
import { TimelineData } from '../milestone.types';
import { cn, getBackgroundClass } from '@workspace/lib';
import { useState, useEffect } from 'react';
import { CustomScrollBar } from '@workspace/ui/common/CustomScrollBar';
import { TimelineHeading } from './TimelineHeading';
import { TimelineItem } from './TimelineItem';

export function MilestoneWithScroll({ heading, timelineItems, backgroundColor }: TimelineData) {
  const backgroundClass = getBackgroundClass(backgroundColor);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className={backgroundClass}>
      <div className="porta-container flex flex-col gap-lg px-md items-center overflow-hidden w-full md:gap-xl py-xl md:px-full-banner md:py-3xl">
        <TimelineHeading text={heading} />

        <div
          className={cn(
            'relative flex flex-col gap-lg w-full',
            'md:flex-row md:items-start md:justify-between md:gap-12',
          )}
        >
          <CustomScrollBar
            maxHeight="max-h-[600px]"
            orientation="both"
            maxWidth="max-w-[1440px]"
            contentClassName={cn(
              'relative flex flex-col w-full h-full overflow-auto p-sm md:-m-sm gap-xl',
              'md:flex-row md:items-start md:justify-between',
            )}
            thumbFixedWidth={262}
            thumbFixedHeight={isMobile ? 200 : undefined}
          >
            {timelineItems?.map((item, idx, arr) => (
              <TimelineItem key={item._key} item={item} isLast={idx === arr.length - 1} isFirst={idx === 0} />
            ))}
          </CustomScrollBar>
        </div>
      </div>
    </div>
  );
}
